import PageHeader from "components/PageHeader";
import React, { useEffect } from "react";
import { useSelector } from "redux/reducer";
import DraftingForm from "modules/partner/settings/components/DraftingForm";
import LoadingOverlay from "components/LoadingOverlay";
import { redirect } from "modules/navigation/helpers/navigator";
import { ROUTE_TEMPLATE } from "modules/navigation/routes";
import { useDispatch } from "react-redux";

type DraftingScreenProps = {
  onStateChange: (state: string) => void;
};

const DraftingScreen: React.FC<DraftingScreenProps> = ({ onStateChange }) => {
  const dispatch = useDispatch();
  const partner = useSelector((state) => state.partner);

  useEffect(() => {
    if (partner && !partner.data.drafting) {
      redirect(dispatch, ROUTE_TEMPLATE.PARTNER_ROOT);
    }
  }, [partner, dispatch]);

  if (!partner) {
    return <LoadingOverlay />;
  }

  return (
    <div>
      <PageHeader title="Drafting" />
      <DraftingForm onStateChange={onStateChange} />
    </div>
  );
};

export default DraftingScreen;
